import { resolveBackendApiBaseUrl } from '../../utils/runtimeEnv.js';

const backendBaseUrl = resolveBackendApiBaseUrl();
const resolveApiPath = (path) => `${backendBaseUrl.replace(/\/$/, '')}${path}`;

export const CHAT_PROXY_URL = resolveApiPath('/api/chat-proxy');
export const TASK_QUERY_PROXY_URL = resolveApiPath('/api/widget-query');
export const LOG_PROXY_URL = resolveApiPath('/api/widget-log');

// Mutable cache object
export const CACHED_DATA = { glossary: "{}", chapter: "[]", difficulty: "[Pending]" };

// Central Error Dictionary
export const ERROR_CODES = {
    "ERR-101": "Initialization Failed",
    "ERR-201": "Database Query Failed",
    "ERR-202": "Invalid Data Structure",
    "ERR-203": "Unsupported Question Type",
    "ERR-301": "LLM Generation Error"
};

// Hardcoded Widget schema — will be replaced by N8N `action: "schema"` endpoint later
export const WIDGET_SCHEMA = {
    source: [
        { value: "THB_publisher", label: "Publisher (THB)" },
        { value: "national_exam", label: "National Exam" }
    ],
    level: [
        { value: "easy", label: "Easy" },
        { value: "medium", label: "Medium" },
        { value: "hard", label: "Hard" }
    ],
    chapter: [
        { value: "ch01", label: "Ch.1" }, { value: "ch02", label: "Ch.2" },
        { value: "ch03", label: "Ch.3" }, { value: "ch04", label: "Ch.4" },
        { value: "ch05", label: "Ch.5" }, { value: "ch06", label: "Ch.6" },
        { value: "ch07", label: "Ch.7" }, { value: "ch08", label: "Ch.8" },
        { value: "ch09", label: "Ch.9" }, { value: "ch10", label: "Ch.10" },
        { value: "ch11", label: "Ch.11" }, { value: "ch12", label: "Ch.12" },
        { value: "ch13", label: "Ch.13" }, { value: "ch14", label: "Ch.14" },
        { value: "ch15", label: "Ch.15" }
    ],
    q_category: [
        { value: "mcq", label: "Multiple Choice" },
        { value: "essay", label: "Essay / Open-ended" }
    ]
};

// Declarative cascade rules — when field X changes to value Y, apply visibility rules to other fields
export const CASCADE_RULES = {
    source: {
        national_exam: {
            chapter: { visible: false, reset: true }
        },
        THB_publisher: {
            chapter: { visible: true }
        }
    }
};
